import { Box } from "@mui/material";
import book from "assets/images/book.webp";

export const LoginHeader = () => (
  <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
    <img src={book} alt="" width={200} height={171} />
  </Box>
);
